import React from 'react'
import { formatToLocalTime } from '../services/WeatherServices'

function TimeAndLocations({weather:{dt,timezone,country,name}}) {
  return (
    <div>
        <div className='flex flex-row justify-center my-6'>
          <p className='text-xl text-white font-extralight'>{formatToLocalTime(dt,timezone )} </p>
        </div>
        <div className='flex flex-row justify-center my-3 '>
          <p className='text-3xl text-white font-medium'>{`${name}, ${country}`}</p>
        </div>

       
    </div>
  )
}

export default TimeAndLocations